import { useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { images } from "../../../../constants";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { SuccessNotify } from "../../../../constants/tostify";
import { paymentmethod } from "../../../../constants/jsonConstant";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../../../helpers/helper";
import Card from "react-bootstrap/Card";
import { FailedNotify } from "../../../../constants/tostify";
import ClearIcon from "@mui/icons-material/Clear";
import url from "../../../../config/axios";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const Investmodal = ({ setPurchase, purchase }) => {
  const navigate = useNavigate();

  const [paymentdata, setPaymentdata] = useState({
    subscriptionName: "",
    subscriptionId: "",
    userid: "",
    shopid: "",
    businessType: "",
    payment: "",
    image: [""],
  });

  const [otp, setOtp] = useState({
    one1: "",
    one2: "",
    one3: "",
    one4: "",
  });
  const [displayimg, setDisplayimg] = useState();
  const handleValue = (e) => {
    setOtp((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    if (e.target.name === "one1" && e.target.value.length === 1) {
      one2.current.focus();
    } else if (e.target.name === "one2" && e.target.value.length === 1) {
      one3.current.focus();
    } else if (e.target.name === "one3" && e.target.value.length === 1) {
      one4.current.focus();
    }
  };
  const one2 = useRef();
  const one3 = useRef();
  const one4 = useRef();

  const onDrop = async (acceptedFiles) => {
    try {
      const abc = await publishImage(acceptedFiles);
      setPaymentdata(() => ({
        ...paymentdata,
        image: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const handleCopy = (text) => {
    // Use the Clipboard API
    navigator.clipboard
      .writeText(text)
      .then(() => {
        SuccessNotify("Text copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  return (
    <>
      <Modal
        size="xl"
        show={purchase}
        onHide={() => setPurchase(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className=""
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-sm-5">
          <Row className="justify-content-center">
            <Col xl={10} md={12} lg={12} sm={12} className="text-center">
              <Modal.Title id="contained-modal-title-vcenter" className="pb-4">
                Payment Details:
              </Modal.Title>

              <Row>
                {paymentmethod?.map((e, index) => (
                  <Col lg="4" key={index}>
                    <Form.Group
                      className="mb-3 text-start"
                      controlId={`payment-method-${index}`}
                    >
                      <Form.Label>{e.label}</Form.Label>
                      <div className="d-flex">
                        <Form.Control
                          type="text"
                          value={e.labelvalue}
                          aria-label="Disabled input example"
                          disabled
                          readOnly
                        />

                        <FileCopyIcon
                          fontSize="small"
                          className="cursor_P mt-2 ms-1"
                          onClick={() => handleCopy(e.labelvalue)}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                ))}
              </Row>

              <Row className="text-start mt-3">
                <h5>Instructions:</h5>
                <ul>
                  <li>
                    <p className="font_13 mb-0">
                      Send Payment according to your selected plan.
                    </p>
                  </li>

                  <li>
                    <p className="font_13 mb-0">
                      Payment Screen Short must be attached.
                    </p>
                  </li>
                </ul>
              </Row>

              <Row className="text-start mt-3">
                <Col lg="8">
                  <h6>Attach Screen Short:</h6>
                  <Row>
                    <Col lg="9" className="me-auto">
                      <Row>
                        <Col lg={3} className="mt-2 ms-1">
                          <Card
                            style={{ width: "6rem", height: "6rem" }}
                            {...getRootProps()}
                            className="dropzone cursor_P"
                          >
                            <Card.Img
                              className="imet-fit"
                              src={images.AddImage}
                            />
                            <Card.Body>
                              <input
                                type="file"
                                id="file"
                                style={{ display: "none" }}
                                {...getInputProps()}
                                multiple
                              />
                            </Card.Body>
                          </Card>
                        </Col>
                        {displayimg?.length > 0 && (
                          <Col lg={7} className=" mt-1 d-flex">
                            {displayimg.map((image, index) => (
                              <Card
                                className="me-2 mt-1"
                                style={{
                                  width: "6rem",
                                  height: "6rem",
                                  border: "2px solid",
                                }}
                              >
                                <Card.Img
                                  className="imet-fit upload-img mt-0"
                                  src={getAsset(image)}
                                  alt=""
                                  crossOrigin="anonymous"
                                />
                                <div
                                  className="close-btnone"
                                  onClick={() => removeImage(index)}
                                >
                                  <ClearIcon />
                                </div>
                              </Card>
                            ))}
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col
                  lg="4"
                  className="d-flex justify-content-end align-items-end"
                >
                  <Button className="cursor_P ps-3 pe-3">Proceed</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Investmodal;
